import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { NgIf } from '@angular/common';

/**
 * Shell for the profile onboarding popups: a centered card on desktop, a bottom sheet on mobile.
 * Figma: IVY-HA "Offer modal" (e.g. 235:14743 desktop, 235:16334 mobile).
 */
@Component({
  selector: 'app-profile-popup',
  standalone: true,
  imports: [NgIf],
  templateUrl: './profile-popup.component.html'
})
export class ProfilePopupComponent implements OnChanges, OnDestroy {
  @Input() open = false;
  /** Closes on a backdrop click or Escape when true. */
  @Input() dismissible = true;
  @Output() dismissed = new EventEmitter<void>();

  ngOnChanges() {
    // Keep the chat behind from scrolling while the popup is up
    document.body.style.overflow = this.open ? 'hidden' : '';
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
  }

  dismiss() {
    if (this.dismissible) {
      this.dismissed.emit();
    }
  }
}
